/* eslint-disable react/jsx-no-undef */
import {
  batchRepeat,
  batchTransferSector,
  batchUncorrelated
} from '@api/announcement';
import { BatchDispatchResponseInterface } from '@api/announcement/type';
import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
// import { userInfo } from '@store';
import { AnnFooterPopup } from '@views/pages/AnnouncementDetails/hooks/Footer/Popup/annFooterPopup';
import { Form, message, Space } from 'antd';
import { forwardRef, useImperativeHandle, useState } from 'react';
// import { useRecoilState } from 'recoil';
import './index.scss';

interface AToolBarPropsInterface {
  getList: () => void;
  noticeCodeList: any[];
}

const AToolBar = (props: AToolBarPropsInterface, ref: any) => {
  const { getList, noticeCodeList } = props;
  const [form] = Form.useForm();
  const [repeatOpen, setRepeatOpen] = useState(false);
  const [isToSalesModalShow, setIsToSalesModalShow] = useState(false);
  const [batchResult, setBatchResult] =
    useState<BatchDispatchResponseInterface>({});
  const [actionId, useActionId] = useState(-1); //3:转销售 2:转Sector同事 5:不相关 6:重复
  // const [userInfos] = useRecoilState(userInfo);

  // 校验表单内容并且返回数据
  const submitClick = (): Promise<any> => {
    return form.validateFields();
  };

  const onModalCancel = () => {
    setIsToSalesModalShow(false);
  };

  const confirmCallback = async (val: any) => {
    let res: BatchDispatchResponseInterface = {};

    if (actionId === 2) {
      //2 :转Sector同事
      if (val.frontEndRemarks) {
        res = await batchTransferSector({
          dispatchUserId: val.frontEndRemarks.dispatchUserId,
          dispatchUserName: val.frontEndRemarks.dispatchUserName,
          noticeCodeList: noticeCodeList,
          recordRemark: val.recordRemark
        });
      } else {
        return message.warning('请先选择一名人员');
      }
    } else if (actionId === 5) {
      //5 : 不相关
      res = await batchUncorrelated({
        noticeCodeList: noticeCodeList,
        recordRemark: val.recordRemark
      });
    } else if (actionId === 6) {
      //6 : 重复
      res = await batchRepeat({
        noticeCodeList: noticeCodeList,
        recordRemark: val.recordRemark
      });
    }
    setBatchResult(res);
    setIsToSalesModalShow(true);
    getList();
  };

  // const onModalOk = async () => {
  //   const res = await batchDispatch({
  //     noticeCodeList
  //   });
  //   setBatchResult(res);
  //   setIsToSalesModalShow(true);
  // };

  const handleDisplayRepeatPopup = (action: number) => {
    setRepeatOpen(true);
    useActionId(action);
  };

  useImperativeHandle(ref, () => ({
    submitClick,
    resetFields: form.resetFields
  }));

  return (
    <>
      <div className="AToolBar_wrap">
        <div className="AToolBar_title">
          {noticeCodeList.length ? `已选择${noticeCodeList.length} 条公告` : ''}
        </div>
        <Space>
          <ZeissButton
            className=""
            onClick={() => handleDisplayRepeatPopup(6)}
            disabled={!noticeCodeList.length}
          >
            重复
          </ZeissButton>
          {/* <ZeissButton
            className=""
            type="primary"
            onClick={onModalOk}
            disabled={!noticeCodeList.length}
          >
            给销售
          </ZeissButton> */}
          <ZeissButton
            className=""
            type="primary"
            ghost
            onClick={() => handleDisplayRepeatPopup(2)}
            disabled={!noticeCodeList.length}
          >
            转交给Sector
          </ZeissButton>
          <ZeissButton
            className=""
            danger
            onClick={() => handleDisplayRepeatPopup(5)}
            disabled={!noticeCodeList.length}
          >
            不相关
          </ZeissButton>
        </Space>
      </div>
      <AnnFooterPopup
        getList={getList}
        noticeCode={noticeCodeList}
        actionId={actionId}
        open={repeatOpen}
        setOpen={setRepeatOpen}
        confirmCallback={confirmCallback}
      />
      <ZeissModal
        title=""
        open={isToSalesModalShow}
        onCancel={onModalCancel}
        onOk={onModalCancel}
        centered
      >
        <h2>全部{batchResult.totalCount}条</h2>
        <h2>成功{batchResult.successCount}条</h2>
        <h2>失败{batchResult.failCount}条</h2>
      </ZeissModal>
    </>
  );
};
export default forwardRef(AToolBar);
